import { Component, Input, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { CommandShareArrayWrapper, PersistenceService } from '../../../services/persistence.service';

@Component({
  selector: 'app-persistence-state-array',
  templateUrl: './persistence-state-array.component.html',
  styleUrls: ['./persistence-state-array.component.css']
})
export class PersistenceStateArrayComponent implements OnInit {

  state: CommandShareArrayWrapper = {
    'failed': 0,
    'pending': 0,
    'succeeded': 0,
    'transaction': null
  };

  @Input() transaction: string;

  _subscriptions: Subscription[] = [];

  constructor(
    private _persistenceService: PersistenceService
  ) {

  }

  ngOnInit(): void {
    this._subscriptions.push(this._persistenceService.commandStateArray$.subscribe((result: CommandShareArrayWrapper) => {
      if(result){
        if(result.transaction === this.transaction){
          this.state = result;
        }
      } else this.state = {
        'failed': 0,
        'pending': 0,
        'succeeded': 0,
        'transaction': null
      };
    }));
  }

}
